// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__Qv5mk","info":"UpdateTermsInfo_info__2zZxt"};